import api from './authService'

export interface ConductorAPI {
  id_conductor: number
  id_organizacion: number
  id_usuario: number | null
  numero_licencia: string
  tipo_licencia: string | null
  vencimiento_licencia: string | null
  estado: string
  fecha_creacion: string
  fecha_actualizacion: string | null
}

export interface Conductor {
  id: string
  idOrganizacion: number
  numeroLicencia: string
  tipoLicencia: string
  vencimientoLicencia: string | null
  estado: string
  idUsuario: string | null
}

export interface ConductorCrear {
  numero_licencia: string
  tipo_licencia?: string
  vencimiento_licencia?: string
  estado?: string
  id_usuario?: number
}

export interface ConductorActualizar {
  numero_licencia?: string
  tipo_licencia?: string
  vencimiento_licencia?: string
  estado?: string
  id_usuario?: number
}

const normalizarConductor = (conductorAPI: ConductorAPI): Conductor => {
  return {
    id: conductorAPI.id_conductor.toString(),
    idOrganizacion: conductorAPI.id_organizacion,
    numeroLicencia: conductorAPI.numero_licencia,
    tipoLicencia: conductorAPI.tipo_licencia || '',
    vencimientoLicencia: conductorAPI.vencimiento_licencia,
    estado: conductorAPI.estado,
    idUsuario: conductorAPI.id_usuario ? conductorAPI.id_usuario.toString() : null
  }
}

export const conductoresService = {
  async obtenerConductores(skip = 0, limit = 100, idOrganizacion?: number): Promise<Conductor[]> {
    try {
      const response = await api.get(`/api/conductores?skip=${skip}&limit=${limit}`)
      const conductores = (response.data as ConductorAPI[]).map(normalizarConductor)

      if (typeof idOrganizacion === 'number') {
        return conductores.filter((conductor) => conductor.idOrganizacion === idOrganizacion)
      }

      return conductores
    } catch (error) {
      console.error('Error al obtener conductores:', error)
      throw error
    }
  },

  async crearConductor(conductor: ConductorCrear): Promise<Conductor> {
    try {
      const response = await api.post('/api/conductores', conductor)
      return normalizarConductor(response.data)
    } catch (error) {
      console.error('Error al crear conductor:', error)
      throw error
    }
  },

  async actualizarConductor(id: string, conductor: ConductorActualizar): Promise<Conductor> {
    try {
      const response = await api.put(`/api/conductores/${id}`, conductor)
      return normalizarConductor(response.data)
    } catch (error) {
      console.error('Error al actualizar conductor:', error)
      throw error
    }
  },

  async eliminarConductor(id: string): Promise<void> {
    try {
      await api.delete(`/api/conductores/${id}`)
    } catch (error) {
      console.error('Error al eliminar conductor:', error)
      throw error
    }
  },

  async obtenerConductorPorId(id: string): Promise<Conductor> {
    try {
      const response = await api.get(`/api/conductores/${id}`)
      return normalizarConductor(response.data)
    } catch (error) {
      console.error('Error al obtener conductor:', error)
      throw error
    }
  }
}
